import React, { useState } from "react";
import LayoutDashboard from "../layout/LayoutDashboard";
import { ReactComponent as BroadcastIcon } from "../assets/icons/broadcast_ico.svg";
import { ReactComponent as ImageSample } from "../assets/images/image-upload.svg";
import { ReactComponent as UploadIcon } from "../assets/icons/upload-icon.svg";
import DynamicScrollToTop from "../components/misc/DynamicScrollToTop";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

const CreateNotification = () => {
  const [dateRange, setdateRange] = useState({
    startDate: null,
    endDate: null,
  });

  const [focus, setFocus] = useState(null);

  const { startDate, endDate } = dateRange;

  const handleOnDateChange = ({ startDate, endDate }) =>
    setdateRange({ startDate, endDate });

  return (
    <>
      <DynamicScrollToTop />
      <LayoutDashboard>
        <section className="ml-4 w-2/4">
          <div className="md-flex">
            <div className="bg-white">
              <div className="mb-12">
                <div className="flex flex-col rounded-md w-full py-6 px-8 bg-white shadow-lg justify-start h-full">
                  <label className="flex items-center mt-4">
                    <span className="text-font-gray w-2/12 flex justify-end mr-6 ">
                      Judul :{" "}
                    </span>
                    <input
                      class="form-input mt-1 w-2/4"
                      placeholder="Tulis Judul"
                    />
                  </label>
                  <label className="flex items-center mt-6">
                    <span className="text-font-gray w-2/12 flex justify-end mr-6 ">
                        Isi Notifikasi
                    </span>
                    <input
                      class="form-input mt-1 w-2/4"
                      placeholder="Tulis isi notifikasi"
                    />
                  </label>
                  <label className="flex items-center mt-4">
                    <span className="text-font-gray w-2/12 flex justify-end mr-6 ">
                      Kota :{" "}
                    </span>
                    <select className="form-select mt-1 block w-6/12">
                      <option>Pilih kota</option>
                      <option>Malang</option>
                      <option>Surabaya</option>
                    </select>
                  </label>
                  <label className="flex items-center mt-4">
                    <span className="text-font-gray w-2/12 flex justify-end mr-6 ">
                      Area :{" "}
                    </span>
                    <select className="form-select mt-1 block w-6/12">
                      <option>Pilih area</option>
                      <option>Area 1</option>
                      <option>Area 2</option>
                      <option>Area 3</option>
                      <option>Area 4</option>
                      <option>Area 5</option>
                    </select>
                  </label>
                  <label className="flex items-center mt-4 ml-16">
                    <Link to="/notification">
                    <button className="bg-green-100 text-white font-bold py-3 px-4 rounded mt-2 flex">
                      <BroadcastIcon className="h4 w-4 mr-4 " />
                      Broadcast
                    </button>
                    </Link>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="ml-4 w-2/4">
          <div className="md-flex">
            <div className="bg-white">
              <div className="mb-12">
                <div className="flex flex-col rounded-md w-4/12 py-2 px-2 bg-white shadow-lg flex-center h-full">
                  <div className="flex flex-col ">
                    <label class="mt-4">
                      <p class="text-gray-700 font-bold text-lg ml-8">
                        Gambar Notifikasi
                      </p>
                      <ImageSample className="m-8" />
                      <button className="ml-8 mb-8 mt-10 border border-gray-500 bg-white rounded">
                        <div className="flex flex-row">
                          <div className="flex">
                            <UploadIcon className="w-4/4 mt-4 ml-4" />
                          </div>
                          <div className="flex">
                            <p className="m-4">Unggah foto</p>
                          </div>
                        </div>
                      </button>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </LayoutDashboard>
    </>
  );
};
export default CreateNotification;
